import { useCallback, useMemo, useRef } from 'react'

import classNames from 'classnames'

import { useHorizontalDragScroll, useHorizontalOverflow } from '@app/hooks'

import { Icon, ListingPicture } from '@lib/components'
import { IconStyles } from '@lib/components/Icon/styles'

import styles from './attachmentsCarousel.module.scss'
import type { AttachmentsCarouselProps } from './types'

export const AttachmentsCarousel = ({
  attachments,
  onRemove,
  containerClassName,
  dragEnabledClassName,
}: AttachmentsCarouselProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const hasHorizontalOverflow = useHorizontalOverflow(containerRef, [
    attachments.length,
  ])

  useHorizontalDragScroll(containerRef, {
    disabled: !hasHorizontalOverflow,
  })

  const handleCardClick = useCallback(() => {}, [])
  const attachmentItems = useMemo(
    () =>
      attachments.map((attachment) => ({
        attachment,
        handleRemove: () => onRemove(attachment.id, attachment.kind),
      })),
    [attachments, onRemove]
  )

  const containerClasses = classNames(
    containerClassName,
    hasHorizontalOverflow && dragEnabledClassName
  )

  return (
    <div
      className={containerClasses}
      ref={containerRef}
    >
      <div className={styles.carousel}>
        {attachmentItems.map(({ attachment, handleRemove }) => (
          <div
            key={`${attachment.kind}-${attachment.id}`}
            className={styles.attachmentCard}
            onClick={handleCardClick}
          >
            <ListingPicture
              url={attachment.cardData.imageUrl}
              alt={attachment.cardData.imageAlt}
              size="small"
              showPlaceholder
              className={styles.picture}
            />
            <div className={styles.details}>
              {attachment.cardData.title && (
                <div className={styles.title}>{attachment.cardData.title}</div>
              )}
              <div className={styles.price}>{attachment.cardData.price}</div>
            </div>
            <button
              type="button"
              className={styles.removeButton}
              onClick={handleRemove}
            >
              <Icon path="icons/icon-cross-thin" style={IconStyles.small} />
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
